import React from "react";
// import Summary from "../../../../images/prescriptionSummary.png";
import Summary from "../../../prescription/Forms/Summary";
import { RiCloseLine } from "react-icons/ri";

const PrescriptionView = ({ onClose, details }) => {
  const closeme = () => {
    console.log('closeme');
  }
  return (
    <>
      <dialog>
        <div className="font-euclid-circular-a w-full h-screen justify-center items-center overflow-hidden m-auto flex">
          <div className="font-euclid-circular-a bg-white w-[760px] top-[11%] right-[18%] shadow flex-col justify-start items-start p-4 overflow-auto">
            <div className="w-full flex justify-end my-10">
              <button onClick={onClose} className="cursor-pointer" >
                <RiCloseLine size={30} />
              </button>
            </div>
            <Summary className="overflow-auto" data={details} />
          </div>
        </div>
      </dialog>
    </>
  );
};

export default PrescriptionView;
